<template>
  <dx-modal title="Usuários conectados" size="md"
            :value="show" @input="close" id="license-sessions-modal">
    <div class="loading loading-lg mt-2" v-if="loading" />
    <template v-else>
      <div class="stats">
        <div class="stat-item">
          <div class="stat-label">Licenças contratadas</div>
          <div class="stat-value">{{ stats.totalLicenses }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">Usuários online</div>
          <div class="stat-value">{{ stats.licensesInUse }}</div>
        </div>
      </div>

      <p class="text-gray mt-2">
        Desconecte um usuário para liberar um acesso. Ele será desconectado na
        próxima ação que fizer no sistema.
      </p>

      <template v-if="userSessions.length === 0">
        <div class="empty">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'users']" size="3x"/>
          </div>
          <p class="empty-title h5">Nenhum usuário ativo</p>
          <p class="empty-subtitle">Não há usuários conectados no momento.</p>
        </div>
      </template>
      <table class="table table-striped table-hover" v-else>
        <thead>
        <tr>
          <th style="min-width: 7rem">Última atividade</th>
          <th>Nome do usuário</th>
          <th>Dispositivo</th>
          <th/>
        </tr>
        </thead>
        <tbody>
        <tr v-for="session in userSessions" :key="session.id">
          <td>{{ session.lastSeenAt | date('DD/MM/YYYY HH:mm') }}</td>
          <td>{{ session.user.name }}</td>
          <td>
            {{ session.device }}
            <div class="text-small text-gray" v-if="session.ip">{{ session.ip }}</div>
            <div
              class="text-small text-gray"
              v-if="session.branches && session.branches.length > 1"
            >Unidades: {{ session.branches.map(({ name }) => name).join(', ') }}</div>
          </td>
          <td class="text-right">
            <button
              class="btn btn-sm btn-action btn-icon btn-error"
              :class="{loading: deleting === session.id}"
              :disabled="deleting !== null"
              @click="disconnect(session)"
            ><fa-icon :icon="['fal', 'sign-out-alt']" /></button>
          </td>
        </tr>
        </tbody>
      </table>
    </template>

    <template slot="footer">
      <router-link
        class="btn btn-primary btn-icon btn-icon-left mr-2"
        to="/customer/licenses"
        @click.native="close"
      >
        <fa-icon :icon="['fal', 'plus']"/>Contratar mais licenças
      </router-link>
      <button class="btn btn-neutral btn-icon btn-icon-left" @click="close">
        <fa-icon :icon="['fal', 'times']"/>Fechar
      </button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  name: 'LicenseSessionsModal',
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      deleting: null,
      stats: {
        totalLicenses: 0,
        licensesInUse: 0,
      },
      userSessions: [],
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) this.load();
      },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async load() {
      this.loading = true;
      try {
        const { data } = await this.$http.get('/customer/licenses');
        this.stats = {
          totalLicenses: data.contract.totalLicenses,
          licensesInUse: data.stats.licensesInUse,
        };
        this.userSessions = data.userSessions;
      } catch (e) {
        this.$toast.error('Não foi possível carregar os usuários conectados.');
      }
      this.loading = false;
    },
    async disconnect(session) {
      this.deleting = session.id;
      try {
        await this.$http.delete(`/sessions/${session.id}`);

        const index = this.userSessions.findIndex(({ id }) => id === session.id);
        if (index > -1) {
          this.userSessions.splice(index, 1);
          this.stats.licensesInUse -= 1;
        }

        this.$toast.success(`${session.user.name} foi desconectado.`);
        await this.$store.dispatch('loadUser');
      } catch (e) {
        this.$toast.error('Ocorreu um erro ao desconectar o usuário. Tente novamente!');
      } finally {
        this.deleting = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

#license-sessions-modal {
  .stats {
    display: grid;
    grid-column-gap: $layout-spacing;
    grid-template-columns: repeat(2, 1fr);
    .stat-item {
      background-color: $gray-color-ultra-light;
      border: $border-width solid $border-color;
      border-radius: $border-radius;
      padding: $layout-spacing $layout-spacing-lg;
    }
    .stat-value {
      color: $primary-color;
      font-size: $unit-5;
      font-weight: 600;
    }
  }
}
</style>
